import { render, staticRenderFns } from "./interOperTable.vue?vue&type=template&id=1ec619ce&scoped=true"
import script from "./interOperTable.vue?vue&type=script&lang=js"
export * from "./interOperTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec619ce",
  null
  
)

export default component.exports